import { all, select, call, fork, put, takeLatest, takeEvery, delay, take } from "redux-saga/effects";
import { API, Storage } from "aws-amplify";
import axios from "axios";
import { upperFirst, titleCase } from "../../helpers/Utils";
import {
  ALACARTE_REQUEST_GET_BY_ID,
  ALACARTE_REQUEST_GET_LIST,
  ALACARTE_REQUEST_GET_LIST_WITH_FILTER,
  REQUEST_ADD_ITEM,
  REQUEST_GET_LIST_DELTA,
  REQUEST_GET_LIST_DELTA_SUCCESS,
  COMMENT_ADD_ITEM,
  REQUEST_GET_ITEM,
  REQUEST_CREATE_QR_IMAGE,
  REQUEST_CREATE_QR_IMAGE_DEEP_LINK,
  TEMPLATE_ADD_MESSAGE,
  TEMPLATE_ADD_MESSAGE_SUCCESS,
  TEMPLATE_ADD_MESSAGE_ERROR
} from "../actions";

import {
  getAlacarteRequestByIdSuccess,
  getAlacarteRequestByIdError,
  getAlacarteRequestListSuccess,
  getAlacarteRequestListError,
  getAlacarteRequestListWithFilterSuccess,
  getAlacarteRequestListWithFilterError,
  getRequestListDeltaSuccess,
  getRequestListDeltaError,
  addRequestItemSuccess,
  addRequestItemError,
  addCommentItemError,
  addCommentItemSuccess,
  requestGetItemError,
  requestGetItemSuccess,
  createRequestQrImageSuccess,
  createRequestQrImageError,
  createRequestQrImageDeepLinkSuccess,
  createRequestQrImageDeepLinkError,
  templateGetItemSucces,
  templateGetItemError,
  updateTempMessageSuccess,
  updateTempMessageError,
  putTempMessageSuccess,
  putTempMessageError,
  addTempMessageSuccess,
  addTempMessageError
} from "./actions";
import moment from "moment";

const FIREBASE_API_KEY = "AIzaSyCLCpyppiXURfM4yQJWI6kL5Gvu2J1YQmQ";
const REQUESTS_BASE = "/requests";
const GET_ALACARTE_REQUEST_LIST = "/requests/alacarteRequestList";

export const getAlacarteRequestByIDAsync = async (hotel_id, timeZone, locale, allowedRequestTypes, allowedServiceIds, alacarteReqId) => {
  const apiName = "WebeeAPI";
  const path = GET_ALACARTE_REQUEST_LIST;
  const myInit = {
    body: { alacarteReqId },
    queryStringParameters: {
      hotel_id,
      ...(allowedRequestTypes && allowedRequestTypes[0] !== "ANY" ? { type: allowedRequestTypes } : {}),
      ...(allowedServiceIds && allowedServiceIds[0] !== "ANY" ? { service_id: allowedServiceIds } : {})
    }
  };
  try {
    const alacarteRequest = await API.post(apiName, path, myInit);
    const alacarteRequestList = mapRequestResult(alacarteRequest, locale, timeZone);
    return { alacarteRequestList }
  } catch (err) {
    throw err;
  }
};

export function* getAlacarteRequestByID({ payload: alacarteReqId }) {
  const state = yield select();
  const { hotelId, alacarte, timeZone = "Europe/Istanbul" } = state.settings.hotelConfig;
  if (!alacarte) return;
  const { allowedRequestTypes, allowedServiceIds } = state.auth.userPrivileges;
  const { locale } = state.settings;
  try {
    const response = yield call(
      getAlacarteRequestByIDAsync,
      hotelId,
      timeZone,
      locale,
      allowedRequestTypes,
      allowedServiceIds,
      alacarteReqId
    );
    yield put(getAlacarteRequestByIdSuccess(response));
  } catch (error) {
    yield put(getAlacarteRequestByIdError({ error }));
  }
}

export function* watchGetAlacarteRequestByID() {
  yield takeEvery(ALACARTE_REQUEST_GET_BY_ID, getAlacarteRequestByID);
}

export const getAlacarteRequestListAsync = async (cachedList, hotel_id, timeZone, locale, allowedRequestTypes, allowedServiceIds, fetchMore, lastEvaluatedKey) => {
  const apiName = "WebeeAPI";
  const path = GET_ALACARTE_REQUEST_LIST;
  const myInit = {
    body: {},
    queryStringParameters: {
      hotel_id,
      ...(allowedRequestTypes && allowedRequestTypes[0] !== "ANY" ? { type: allowedRequestTypes } : {}),
      ...(allowedServiceIds && allowedServiceIds[0] !== "ANY" ? { service_id: allowedServiceIds } : {})
    }
  };
  if (typeof lastEvaluatedKey === 'object') {
    myInit.body.lastEvaluatedKey = lastEvaluatedKey
  }
  if (fetchMore && cachedList.length) {
    myInit.body.last_updated_at_max = Math.min(...cachedList.map(({ updated_at }) => updated_at));
  } else {
    myInit.body.last_updated_at = cachedList.length ? Math.max(...cachedList.map(({ updated_at }) => updated_at)) : 1;
  }
  try {
    let { alacarteRequestList, alacarteReqListLastEvaluatedKey } = await API.post(apiName, path, myInit);
    alacarteRequestList = mapRequestResult(alacarteRequestList, locale, timeZone);
    if (!fetchMore && !alacarteReqListLastEvaluatedKey) alacarteReqListLastEvaluatedKey = true;
    return { alacarteRequestList, alacarteReqListLastEvaluatedKey };
  } catch (err) {
    throw err;
  }
};

export function* getAlacarteRequestList({ payload: fetchMore }) {
  const state = yield select();
  let { hotelId, alacarte, timeZone = "Europe/Istanbul" } = state.settings.hotelConfig;
  if (!alacarte) return;
  const { allowedRequestTypes, allowedServiceIds } = state.auth.userPrivileges;
  const { alacarteReqListLastEvaluatedKey: lastEvaluatedKey } = state.requestApp;
  const { locale } = state.settings;
  try {
    const response = yield call(
      getAlacarteRequestListAsync,
      Object.values(state.requestApp.allAlacarteItems),
      hotelId,
      timeZone,
      locale,
      allowedRequestTypes,
      allowedServiceIds,
      fetchMore,
      lastEvaluatedKey,
    );
    yield put(getAlacarteRequestListSuccess(response));
  } catch (error) {
    yield put(getAlacarteRequestListError({ error }));
  }
}

export function* watchGetAlacarteRequestList() {
  yield takeEvery(ALACARTE_REQUEST_GET_LIST, getAlacarteRequestList);
}

export const getAlacarteRequestListWithFilterAsync = async (hotel_id, timeZone, locale, allowedRequestTypes, allowedServiceIds, payload) => {
  if (payload && payload.value && payload.value !== "") {
    const selectedAlacarteValue = payload.selectedOptions[0].value;
    const selectedDate = payload.selectedOptions[1].label;
    const apiName = "WebeeAPI";
    const path = GET_ALACARTE_REQUEST_LIST;
    const myInit = {
      body: {
        selectedAlacarteValue,
        selectedDate,
        timeZone
      },
      queryStringParameters: {
        hotel_id,
        ...(allowedRequestTypes && allowedRequestTypes[0] !== "ANY" ? { type: allowedRequestTypes } : {}),
        ...(allowedServiceIds && allowedServiceIds[0] !== "ANY" ? { service_id: allowedServiceIds } : {})
      }
    };
    try {
      let filteredAlacarteRequestList = await API.post(apiName, path, myInit);
      filteredAlacarteRequestList = mapRequestResult(filteredAlacarteRequestList, locale, timeZone);
      return { filteredAlacarteRequestList, ...payload };
    } catch (err) {
      throw err;
    }
  }
  return { ...payload };
};

export function* getAlacarteRequestListWithFilter({ payload }) {
  const state = yield select();
  const { hotelId, alacarte, timeZone = "Europe/Istanbul" } = state.settings.hotelConfig;
  if (!alacarte) return;
  const { allowedRequestTypes, allowedServiceIds } = state.auth.userPrivileges;
  const { locale } = state.settings;
  try {
    const response = yield call(getAlacarteRequestListWithFilterAsync, hotelId, timeZone, locale, allowedRequestTypes, allowedServiceIds, payload);
    yield put(getAlacarteRequestListWithFilterSuccess(response));
  } catch (error) {
    yield put(getAlacarteRequestListWithFilterError({ error }));
  }
}

export function* watchGetAlacarteRequestListWithFilter() {
  yield takeEvery(ALACARTE_REQUEST_GET_LIST_WITH_FILTER, getAlacarteRequestListWithFilter);
}

const turnMultilanguageHashmapsIntoObjectsInRequest = (request, language) => {
  if (language && request.serviceWithLocales) {
    if (request.service_id && request.serviceWithLocales[request.service_id]) {
      if (request.serviceWithLocales[request.service_id][language]) {
        request.service = Object.assign({}, request.serviceWithLocales[request.service_id][language]);
      } else if (request.serviceWithLocales[request.service_id].en) {
        request.service = Object.assign({}, request.serviceWithLocales[request.service_id].en);
      }
    } else if (request.service_type && request.serviceWithLocales[request.service_type]) {
      if (request.serviceWithLocales[request.service_type][language]) {
        request.service = Object.assign({}, request.serviceWithLocales[request.service_type][language]);
      } else if (request.serviceWithLocales[request.service_type].en) {
        request.service = Object.assign({}, request.serviceWithLocales[request.service_type].en);
      }
    }
  }
  if (request.staffSummaryWithLocales) {
    if (request.staffSummaryWithLocales[language]) {
      request.staff_summary = request.staffSummaryWithLocales[language];
    } else if (request.staffSummaryWithLocales.en) {
      request.staff_summary = request.staffSummaryWithLocales.en;
    } else {
      [request.staff_summary] = Object.values(request.staffSummaryWithLocales);
    }
  }

  request.req_room_number = request.room_number;

  return request;
};

export const addSoftFields = (item, locale = "en", timeZone = "Europe/Istanbul") => {
  if (!timeZone || timeZone === undefined) {
    timeZone = "Europe/Istanbul";
  }
  const options = {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h24",
    hour12: false,
    timeZone
  };

  const optionsWithoutHourAndMinute = {
    year: "numeric",
    month: "long",
    day: "numeric",
    hourCycle: "h24",
    hour12: false,
    timeZone
  };

  const toReturn = turnMultilanguageHashmapsIntoObjectsInRequest(item, locale);

  const { booking } = item;
  if (booking) {
    toReturn.checkin = parseInt(booking.checkin, 10);
    toReturn.checkout = parseInt(booking.checkout, 10);
    toReturn.checkin_date = new Date(toReturn.checkin * 1000).toLocaleDateString(locale, optionsWithoutHourAndMinute);
    toReturn.checkout_date = new Date(toReturn.checkout * 1000).toLocaleDateString(locale, optionsWithoutHourAndMinute);
    toReturn.hotel_name = booking.hotel_name;
    toReturn.booking_status = booking.status;
    if (booking.rooms && booking.rooms.length) toReturn.room_number = booking.rooms.join(",");
  }
  if (item.due_at) toReturn.due_at = parseInt(item.due_at, 10);
  if (item.updated_at) toReturn.updated_at = parseInt(item.updated_at, 10);
  if (item.created_at) toReturn.created_at = parseInt(item.created_at, 10);

  if (toReturn.due_at) toReturn.due_at_date = new Date(toReturn.due_at * 1000).toLocaleDateString(locale, options);
  if (toReturn.updated_at) toReturn.updated_at_date = new Date(toReturn.updated_at * 1000).toLocaleDateString(locale, options);
  if (toReturn.created_at) toReturn.created_at_date = new Date(toReturn.created_at * 1000).toLocaleDateString(locale, options);

  if (toReturn.comments && toReturn.comments.length) {
    toReturn.comments = toReturn.comments.map(comment => {
      comment.created_at_date = new Date(comment.created_at * 1000).toLocaleDateString(locale, options);
      return comment;
    });
  }

  if (toReturn.service && toReturn.service.name) {
    toReturn.service.name = titleCase(toReturn.service.name, locale);
    toReturn.serviceName = toReturn.service.name;
  }

  const { user } = item;
  if (user) {
    toReturn.fullName = `${upperFirst(user.name)} ${upperFirst(user.family_name)}`;
    toReturn.phone_number = user.phone_number;
  }
  delete toReturn.user;

  return toReturn;
};

export const mapRequestResult = (requests, locale, timeZone) => {
  if (requests instanceof Array) {
    if (requests.length === 1) {
      const request = addSoftFields(requests[0], locale, timeZone);
      return [request];
    }
    return requests.map(item => {
      return addSoftFields(item, locale, timeZone);
    });
  }
  if (requests instanceof Object) {
    return addSoftFields(requests, locale, timeZone);
  }

  return [];
};

export const createQrImageAsync = async payload => {
  const {
    firstName,
    lastName,
    phone_number,
    email,
    hotel_id,
    checkIn,
    checkOut,
    roomNo,
    andorid_bundle_id,
    ios_bundle_id,
    app_store_id,
    googleCloudApiKey,
    webeePassDomainUrl,
    user_pool_id,
    source
  } = payload;

  const dateObjectcIn = moment(checkIn, "YYYY-MM-DD");
  const unixCheckin = dateObjectcIn.unix();

  const dateObjectcOut = moment(checkOut, "YYYY-MM-DD");
  const unixCheckout = dateObjectcOut.unix();

  const apiName = "WebeeAPI";
  let path = `/utilities/URLShortener/shortener`;

  const linkRequest = {
    user_pool_id,
    checkIn,
    checkOut,
    phone_number,
    email,
    integration_type: "webee_pass",
    cdn_prefix: "pass.webee.app",
    url_long: `${webeePassDomainUrl}?` +
      `firstName=${encodeURIComponent(firstName)}` +
      `&lastName=${encodeURIComponent(lastName)}` +
      `&userId=${email ? encodeURIComponent(email) : encodeURIComponent(phone_number)}` +
      `&hotelId=${encodeURIComponent(hotel_id)}` +
      `&checkInDate=${encodeURIComponent(unixCheckin)}` +
      `&checkOutDate=${encodeURIComponent(unixCheckout)}` +
      `&roomNumber=${encodeURIComponent(roomNo)}` +
      `&source=${encodeURIComponent(source)}`
  };
  if (window?.location?.href?.includes(".test-")) {
    linkRequest.cdn_prefix = "dev.getwebee.com/utilities/URLShortener";
  }

  try {
    const result = await API.post(apiName, path, { body: linkRequest });
    return result;
  } catch (err) {
    // console.error('Create qr deep link error in async', err);
    throw err;
  }
};

export const createQrImageDeepLinkAsync = async payload => {
  const url = `https://firebasedynamiclinks.googleapis.com/v1/shortLinks?key=${FIREBASE_API_KEY}`;
  try {
    const result = await axios.post(url, payload, {
      headers: {
        "Content-Type": "application/json"
      }
    });
    return result;
  } catch (err) {
    // console.error('Create qr deep link error in async', err);
    throw err;
  }
};

export const getRequestListDeltaAsync = async (cachedList, hotelId, timeZone, locale, allowedRequestTypes, allowedServiceIds, fetchMore) => {
  const apiName = "WebeeAPI";
  const myInit = {
    queryStringParameters: {
      hotel_id: hotelId,
      ...(allowedRequestTypes && allowedRequestTypes[0] !== "ANY" ? { type: allowedRequestTypes } : {}),
      ...(allowedServiceIds && allowedServiceIds[0] !== "ANY" ? { service_id: allowedServiceIds } : {})
    },
    timeout: 30 * 1000
  };
  if (fetchMore && cachedList.length) {
    myInit.queryStringParameters.last_updated_at_max = Math.min(...cachedList.map(({ updated_at }) => updated_at));
  } else {
    myInit.queryStringParameters.last_updated_at = cachedList.length ? Math.max(...cachedList.map(({ updated_at }) => updated_at)) : 1;
  }

  const result = await API.get(apiName, REQUESTS_BASE, myInit);
  return mapRequestResult(result, locale, timeZone);
};

export function* createQr({ payload }) {
  try {
    const state = yield select();
    const { awsCognitoUserPoolId } = state.settings.hotelConfig;
    payload["user_pool_id"] = awsCognitoUserPoolId;
    const response = yield call(createQrImageAsync, payload);

    // Create a new object with the parsed body
    const updatedResponseObject = {
      data: {
        body: response
      }
    };

    yield put(createRequestQrImageSuccess(updatedResponseObject));
  } catch (error) {
    // console.error('create Qr error:', error);
    yield put(createRequestQrImageError({ error }));
  }
}

export function* watchCreateQr() {
  yield takeEvery(REQUEST_CREATE_QR_IMAGE, createQr);
}

export function* createQrDeepLink({ payload }) {
  try {
    const response = yield call(createQrImageDeepLinkAsync, payload);
    yield put(createRequestQrImageDeepLinkSuccess(response));
  } catch (error) {
    // console.error('create Qr Deep Link error:', error);
    yield put(createRequestQrImageDeepLinkError({ error }));
  }
}

export function* watchCreateQrDeepLink() {
  yield takeEvery(REQUEST_CREATE_QR_IMAGE_DEEP_LINK, createQrDeepLink);
}

export function* getRequestListItemsDelta({ payload: fetchMore }) {
  try {
    yield delay(5);
    const state = yield select();
    const { hotelId, timeZone } = state.settings.hotelConfig;
    const { allowedRequestTypes, allowedServiceIds } = state.auth.userPrivileges;
    const { locale } = state.settings;
    const response = yield call(
      getRequestListDeltaAsync,
      Object.values(state.requestApp.allRequestItems),
      hotelId,
      timeZone,
      locale,
      allowedRequestTypes,
      allowedServiceIds,
      fetchMore
    );
    yield put(getRequestListDeltaSuccess(response, fetchMore));
  } catch (error) {
    yield put(getRequestListDeltaError(error));
  }
}

export function* watchGetListDelta() {
  yield takeLatest(REQUEST_GET_LIST_DELTA, getRequestListItemsDelta);
}

export const addRequestItemRequest = async (payload, api = API, locale, timeZone) => {
  try {
    const apiName = "WebeeAPI";
    const requestId = payload.id;

    let path = `${REQUESTS_BASE}`;
    let result = false;

    if (requestId) {
      path += `/${requestId}`;
      result = await api.patch(apiName, path, { body: { ...payload } });
    } else {
      result = await api.post(apiName, path, { body: { ...payload } });
    }
    return mapRequestResult(result, locale, timeZone);
  } catch (err) {
    console.error("requestErr", err);
    throw err;
  }
};

function* addRequestItem({ payload }, api = API) {
  let snapshot;
  try {
    snapshot = yield select(state => state.requestApp);
    const { locale } = yield select(state => state.settings);
    const { timeZone } = yield select(state => state.settings.hotelConfig);
    const response = yield call(addRequestItemRequest, payload, api, locale, timeZone);
    yield put(addRequestItemSuccess(response));
  } catch (error) {
    yield put(addRequestItemError({ snapshot, error }));
  }
}

export function* wathcAddRequestItem() {
  yield takeEvery(REQUEST_ADD_ITEM, addRequestItem);
}

export const uploadToS3 = async payload => {
  try {
    const { file, ...body } = payload;
    if (file) {
      const extension = file.name
        .split(".")
        .slice(-1)
        .pop();
      const { request_id, hotel_id, id } = body;
      const newFileName = `${hotel_id}/${request_id}/${id}.${extension}`;
      return await Storage.put(newFileName, file, {
        contentType: file.type,
        acl: "public-read"
      });
    }
    return "done";
  } catch (err) {
    console.error("RequestErr", err);
    throw err;
  }
};

export const addCommentItemRequest = async (payload, api = API) => {
  try {
    const requestId = payload.request_id;
    const path = `${REQUESTS_BASE}/comments/${requestId}`;
    const { file, ...body } = payload;
    return await api.post("WebeeAPI", path, { body: { ...body, is_staff: "true" } });
  } catch (err) {
    console.error("RequestErr", err);
    throw err;
  }
};

export const updateTempMessageRequest = async (payload, api = API, hotel_id) => {
  const path = `/requests/updateTemplate`;
  const myInit = {
    queryStringParameters: {
      hotel_id
    },
    body: { ...payload }
  };
  return api.post("WebeeAPI", path, myInit);
};

export const putTempMessageRequest = async (payload, api = API, hotel_id) => {
  const path = `/requests/putTemplate`;
  const myInit = {
    queryStringParameters: {
      hotel_id
    },
    body: { ...payload }
  };
  return api.post("WebeeAPI", path, myInit);
};

export const addTempMessageRequest = async (payload, api = API, hotel_id) => {
  const path = `/requests/addTemplate`;
  const myInit = {
    queryStringParameters: {
      hotel_id
    },
    body: { hotel_id, ...payload }
  };
  return api.post("WebeeAPI", path, myInit);
};

export function* addCommentItemSaga({ payload }, api = API) {
  let snapshot;
  try {
    snapshot = yield select(state => state.requestApp);
    const uploadResponse = yield call(uploadToS3, payload, api);
    const response = yield call(addCommentItemRequest, payload, api);
    yield take(REQUEST_GET_LIST_DELTA_SUCCESS);
    yield put(addCommentItemSuccess(response));
  } catch (error) {
    yield put(addCommentItemError({ snapshot, error }));
  }
}

export function* updateTempMessageSaga({ payload }, api = API) {
  let snapshot;
  try {
    snapshot = yield select(state => state.requestApp);
    const state = yield select();
    const { hotelId } = state.settings.hotelConfig;
    const response = yield call(updateTempMessageRequest, payload, api, hotelId);
    yield put(updateTempMessageSuccess(response));
  } catch (error) {
    yield put(updateTempMessageError({ snapshot, error }));
  }
}

export function* putTempMessageSaga({ payload }, api = API) {
  let snapshot;
  try {
    snapshot = yield select(state => state.requestApp);
    const state = yield select();
    const { hotelId } = state.settings.hotelConfig;
    const response = yield call(putTempMessageRequest, payload, api, hotelId);
    yield put(putTempMessageSuccess(response));
  } catch (error) {
    yield put(putTempMessageError({ snapshot, error }));
  }
}

export function* addTempMessageSaga({ payload }, api = API) {
  let snapshot;
  try {
    snapshot = yield select(state => state.requestApp);
    const state = yield select();
    const { hotelId } = state.settings.hotelConfig;
    const response = yield call(addTempMessageRequest, payload, api, hotelId);
    yield put(addTempMessageSuccess(response));
  } catch (error) {
    yield put(addTempMessageError({ snapshot, error }));
  }
}

export function* wathcAddCommentItem() {
  yield takeEvery(COMMENT_ADD_ITEM, addCommentItemSaga);
}

export function* wathcUpdateTempMessage() {
  yield takeEvery("UPDATE_TEMP_MESSAGE", updateTempMessageSaga);
}

export function* wathcPutTempMessage() {
  yield takeEvery("PUT_TEMP_MESSAGE", putTempMessageSaga);
}

export function* wathcAddTempMessage() {
  yield takeEvery("TEMPLATE_ADD_MESSAGE", addTempMessageSaga);
}

export const getRequestWithIdRequest = async (payload, api = API, locale, timeZone, allowedRequestTypes) => {
  try {
    const apiName = "WebeeAPI";
    const requestId = payload.request_id;
    const { isTranslationNeeded } = payload;
    const translationNeededText = isTranslationNeeded ? "true" : "false";
    const path = `${REQUESTS_BASE}/${requestId}${"?is_translation_needed="}${translationNeededText}${"&target_language="}${locale}`;
    const result = await api.get(apiName, path);
    return mapRequestResult(result, locale, timeZone);
  } catch (err) {
    throw err;
  }
};

export function* getRequestWithIdSaga({ payload }, api = API) {
  try {
    const state = yield select();
    const { locale } = state.settings;
    const { timeZone } = state.settings.hotelConfig;
    const { allowedRequestTypes } = state.auth.userPrivileges;
    const response = yield call(getRequestWithIdRequest, payload, api, locale, timeZone, allowedRequestTypes);
    yield put(requestGetItemSuccess(response));
  } catch (error) {
    // console.error('error in getRequestWithIdSaga', error);
    yield put(requestGetItemError(error));
  }
}

export const getTemplatetWithIdRequest = async (payload, api = API, locale, timeZone, allowedRequestTypes, hotel_id) => {
  try {
    const apiName = "WebeeAPI";
    const path = `/requests/getTemplate`;
    const myInit = {
      queryStringParameters: {
        hotel_id
      }
    };
    const result = await api.get(apiName, path, myInit);
    return mapRequestResult(result, locale, timeZone);
  } catch (err) {
    // console.error('RequestErr in getRequestWithIdRequest', err);
    throw err;
  }
};

export function* getTemplateWithIdSaga({ payload }, api = API) {
  try {
    const state = yield select();
    const { locale } = state.settings;
    const { timeZone } = state.settings.hotelConfig;
    const { allowedRequestTypes } = state.auth.userPrivileges;
    const { hotelId } = state.settings.hotelConfig;
    const response = yield call(getTemplatetWithIdRequest, payload, api, locale, timeZone, allowedRequestTypes, hotelId);
    yield put(templateGetItemSucces(response));
  } catch (error) {
    // console.error('error in getRequestWithIdSaga', error);
    yield put(templateGetItemError(error));
  }
}

export function* wathcRequestGetItem() {
  yield takeEvery(REQUEST_GET_ITEM, getRequestWithIdSaga);
}

export function* wathcTemplateGetItem() {
  yield takeEvery("TEMPLATE_GET_ITEM", getTemplateWithIdSaga);
}

export default function* rootSaga() {
  yield all([
    fork(watchGetAlacarteRequestByID),
    fork(watchGetAlacarteRequestList),
    fork(watchGetAlacarteRequestListWithFilter),
    fork(watchGetListDelta),
    fork(wathcAddCommentItem),
    fork(wathcUpdateTempMessage),
    fork(wathcAddTempMessage),
    fork(wathcPutTempMessage),
    fork(wathcAddRequestItem),
    fork(wathcRequestGetItem),
    fork(wathcTemplateGetItem),
    fork(watchCreateQr),
    fork(watchCreateQrDeepLink)
  ]);
}
